import React from "react";
import { createSearchParams, Link } from "react-router-dom";
import CustomSlider from "./CustomSlider";
import Card from "./Card";
import Loading from "../../../Common/Loading";
import { HiOutlineChevronLeft } from "react-icons/hi";
import { useReserve } from "../Hooks";
const OffSlider = ({ data = {}, loading }) => {
  const { navigate, renderCategory } = useReserve();
  if (loading) {
    return (
      <div className="row my-4 ">
        <div className="col-12">
          <Loading count={1} height={400} />
        </div>
      </div>
    );
  }
  if ((data && data.offeritems.length == 0) || data.offeritems.length < 3) {
    return <></>;
  }
  return (
    <div className=" my-4 off-box">
      <div className="row">
        <div className="col-md-4 col-lg-3 ">
          <div className="col-off-content">
            <div className="off-content">
              <div>
                <span>بلیت استخر</span>
              </div>
              <div className="d-flex justify-content-center">
                <span>از نیکوتن</span>
              </div>
              <div className="d-flex justify-content-end">
                <span>با تخفیف بخر</span>
              </div>
            </div>

            <div className="off-img">
              <img
                className="off-img-banner"
                src={window.origin + "/img/ba.png"}
              />
            </div>
          </div>

          <div className="show-all-box">
            <span
              style={{ cursor: "pointer" }}
              className="show-all"
              onClick={() => {
                navigate({
                  pathname: "/Items",
                  search:
                    "?" +
                    createSearchParams({
                      category_id: renderCategory().id,
                    }),
                });
              }}
            >
              مشاهده همه
              <HiOutlineChevronLeft
                size={"1.5rem"}
                style={{ verticalAlign: "center" }}
              />
            </span>
          </div>
        </div>

        <div
          className="col-md-8 col-lg-9 off-slider"
          style={{ padding: "0 40px" }}
        >
          <CustomSlider
            data={data.offeritems}
            renderCard={(data, key) => {
              return <Card isOff={true} data={data} key={key} />;
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default OffSlider;
